import "./SingleNotif.scss";

import { useState, useRef } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Popconfirm, message, Dropdown, Typography, Tooltip } from "antd";
import {
  DeleteIcon,
  LajmerimeIcon,
  LexoMeShum,
} from "../../../../../assets/icons";
import dayjsTZ from "../../../../../utils/dayjs";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { useAuth } from "../../../../../authentication/authHelpers";

const { Paragraph } = Typography;

function SingleNotif({
  content,
  deleteNotif,
  markRead,
  hideNotif,
  toggleRead,
  handleCancel,
}) {
  const notifRef = useRef();
  const { userRole } = useAuth();
  const navigate = useNavigate();

  const { isDarkMode } = useSelector((state) => state.usersList);

  const [ellipsis, setEllipsis] = useState(true);

  const handleDelete = (notifID, content) => {
    notifRef.current.classList.add("out");
    setTimeout(() => {
      notifRef.current.classList.remove("out");
      setTimeout(() => {
        deleteNotif(notifID, content);
      }, 100);
    }, 1000);
  };
  const handleHide = (notifID, markedHidden, notifContent) => {
    notifRef.current.classList.add("out");
    setTimeout(() => {
      notifRef.current.classList.remove("out");
      setTimeout(() => {
        hideNotif(notifID, markedHidden, notifContent);
      }, 100);
    }, 1000);
  };

  const isMobileView = useMediaQuery({
    query: "(min-width: 460px)",
  });

  // useEffect(() => {
  //   console.log(content);
  // }, [content]);
  const items = [
    {
      key: 1,
      label: (
        <span
          style={{ width: "100%" }}
          onClick={() =>
            toggleRead(
              content?.notificationId,
              content?.notificationMarkedRed,
              content
            )
          }
        >
          {content?.notificationMarkedRed === true
            ? "Shëno si të palexuar"
            : "Shëno si të lexuar"}
        </span>
      ),
    },
    {
      key: 2,
      label: (
        <span
          style={{ width: "100%" }}
          onClick={() =>
            handleHide(
              content?.notificationId,
              content?.notificationMarkedHidden,
              content
            )
          }
        >
          {content?.notificationMarkedHidden === true ? "Shfaq" : "Fshih"}
        </span>
      ),
    },
  ];
  let div = document.createElement("div");
  div.innerHTML = content?.notificationBody;
  return (
    <div
      className={
        content?.notificationMarkedRed ? "single-notif read" : "single-notif"
      }
      ref={notifRef}
    >
      {isMobileView ? (
        <>
          <div
            className="notif-content"
            onClick={() => markRead(content?.notificationId, content)}
          >
            <span
              className={
                content?.notificationPriority === true
                  ? "notif-icon important"
                  : "notif-icon"
              }
            >
              {content?.notificationMarkedRed ? (
                <span className="original">
                  {" "}
                  <LajmerimeIcon />{" "}
                </span>
              ) : (
                <span className="white">
                  {" "}
                  <LajmerimeIcon />{" "}
                </span>
              )}

              {/* {content?.notificationID} */}
            </span>
            <span
              onClick={() => {
                if (userRole === "Admin" || userRole === "Super Admin") {
                  navigate(`${content.notificationUrl}`);
                  handleCancel();
                }
              }}
              className="notif-body"
            >
              <b>{content.notificationTitle}</b>
              &nbsp; {"  ‒ "}&nbsp;
              <Paragraph
                style={{ width: 500 }}
                ellipsis={
                  ellipsis ? (
                    <Tooltip
                      placement="top"
                      classNames={{ root: "global-icon-tooltip" }}
                      title={ellipsis ? "Lexo më shumë" : "Lexo më pak"}
                    >
                      <div
                        className="lexo-me-shum-icon"
                        onClick={() => {
                          setEllipsis(!ellipsis);
                        }}
                      >
                        <LexoMeShum width={22} height={22} />
                      </div>
                    </Tooltip>
                  ) : (
                    false
                  )
                }
              >
                {div.innerText}
              </Paragraph>
            </span>
          </div>
          <div className="notif-time">
            <Tooltip
              placement="top"
              classNames={{ root: "global-icon-tooltip" }}
              title={dayjsTZ(content?.createdAt).format("DD/MM/YYYY || HH:mm")}
            >
              <span className="relative-time">
                {dayjsTZ(content?.createdAt).fromNow()}
              </span>
            </Tooltip>
          </div>

          <div className="notif-actions">
            <Tooltip
              placement="top"
              classNames={{ root: "globalPopover" }}
              title={ellipsis ? "Lexo më shumë" : "Lexo më pak"}
            >
              <div
                className="lexo-me-shum-icon"
                onClick={() => {
                  setEllipsis(!ellipsis);
                }}
              >
                <LexoMeShum width={22} height={22} />
              </div>
            </Tooltip>
            <Dropdown
              classNames={{ root: "singleNotifPopconfirm" }}
              popupClassName={isDarkMode ? "darkDropdown" : ""}
              menu={{ items }}
              placement="bottomLeft"
            >
              <div className="show-more-icon">
                <MoreOutlined />
              </div>
            </Dropdown>
            <Popconfirm
              classNames={{ root: `globalPopover ${isDarkMode ? "dark" : ""}` }}
              title="A jeni të sigurt që doni të fshini këtë njoftim?"
              onConfirm={() => handleDelete(content?.notificationId, content)}
              onCancel={() => message.error("Veprimi U anullua!")}
              placement="left"
              okText="Po, fshi!"
              cancelText="Jo, anullo!"
            >
              {" "}
              <div className="delete-icon">
                <DeleteIcon width={20} height={20} fill="#fbfbfb" />
              </div>
            </Popconfirm>
          </div>
        </>
      ) : (
        <>
          <div
            className="notif-content"
            onClick={() => markRead(content?.notificationId, content)}
          >
            <span
              className={
                content?.notificationPriority === true
                  ? "notif-icon important"
                  : "notif-icon"
              }
            >
              {content?.notificationMarkedRed ? (
                <span className="original">
                  {" "}
                  <LajmerimeIcon />{" "}
                </span>
              ) : (
                <span className="white">
                  {" "}
                  <LajmerimeIcon />{" "}
                </span>
              )}

              {/* {content?.notificationID} */}
            </span>
            <span
              onClick={() => {
                navigate(`${content.notificationUrl}`);
                handleCancel();
              }}
              className="notif-body"
            >
              <b>{content.notificationTitle}</b>
              &nbsp; {"  ‒ "}&nbsp;
              {div.innerText}
              <br />
              <span className="relative-time">
                {dayjsTZ(content?.createdAt).fromNow()}
              </span>
            </span>
          </div>
          <div className="notif-actions">
            <Dropdown
              popupClassName={isDarkMode ? "darkDropdown" : ""}
              menu={{ items }}
              classNames={{ root: "singleNotifPopconfirm" }}
              placement="bottomLeft"
            >
              <div className="show-more-icon">
                <MoreOutlined />
              </div>
            </Dropdown>
            <Popconfirm
              title="A jeni të sigurt që doni të fshini këtë njoftim?"
              onConfirm={() => handleDelete(content?.notificationId, content)}
              onCancel={() => message.error("Veprimi U anullua!")}
              placement="left"
              okText="Po, fshi!"
              classNames={{ root: `globalPopover ${isDarkMode ? "dark" : ""}` }}
              cancelText="Jo, anullo!"
            >
              {" "}
              <div className="delete-icon">
                <DeleteIcon width={20} height={20} fill="#fbfbfb" />
              </div>
            </Popconfirm>
          </div>
        </>
      )}
    </div>
  );
}
export default SingleNotif;
